import { Component, inject } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-config-management",
	templateUrl: "./config-management.component.html",
	styleUrls: ["./config-management.component.scss"],
	imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class ConfigManagementComponent {
	api = inject(ApiService);
}
